import React from "react";
import aiPoweredAutomation from "../../assets/images/technology/AI-powered-automation.png";
import bigDataIntegration from "../../assets/images/technology/big-data-integration.png";
import cloudBasedScale from "../../assets/images/technology/cloud-based-scalablity.png";
import advanceCustomization from "../../assets/images/technology/advance-customization.png";
import iotIntegration from "../../assets/images/technology/IOT-integration.png";
import continuousInnovation from "../../assets/images/technology/continous-innovation.png";

const features = [
  {
    icon: aiPoweredAutomation,
    title: "AI-Powered Automation",
    desc: "Our platform uses artificial intelligence to automate repetitive tasks, deliver predictive insights, and optimize workflows. From lead scoring to customer engagement, AI ensures smarter decisions and faster results.",
  },
  {
    icon: bigDataIntegration,
    title: "Big Data Integration",
    desc: "Harness the power of big data with tools that analyze vast datasets to provide actionable insights. Understand customer behavior, predict trends, and refine strategies based on real-time data.",
  },
  {
    icon: cloudBasedScale,
    title: "Cloud-Based Scalability",
    desc: "Built on robust cloud technology, our tool ensures seamless scalability to match your business growth. Enjoy 24/7 access, enhanced security, and minimal downtime.",
  },
  {
    icon: advanceCustomization,
    title: "Advanced Customization",
    desc: "Our platform adapts to your unique needs with customizable modules, ensuring that your team gets the exact tools they need to succeed.",
  },
  {
    icon: iotIntegration,
    title: "IoT Integration",
    desc: "Stay connected to the world of devices. With IoT-enabled features, track customer interactions across multiple touchpoints and create a unified experience.",
  },
  {
    icon: continuousInnovation,
    title: "Continuous Innovation",
    desc: "We don’t just stop at delivering today’s technology. Our dedicated R&D team is always working to enhance the platform, integrating new technologies like machine learning, blockchain, and advanced APIs to future-proof your business.",
  },
];

const FeaturesList = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100" id="technology-features">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Section Header */}
        <div className="tw-text-center tw-mb-16">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
            Capabilities
          </span>
          <h2 className="tw-text-3xl sm:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
            Features That'll Make You Go WOW!
          </h2>
        </div>

        {/* Card Grid */}
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-8">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="tw-group tw-relative tw-overflow-hidden tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.02] tw-transition-all tw-duration-300 tw-text-left tw-flex tw-flex-col"
            >
              {/* Ghost Watermark Icon */}
              <img
                src={item.icon}
                alt=""
                className="tw-absolute tw-bottom-[-16px] tw-right-[-16px] tw-w-28 tw-h-28 tw-opacity-[0.06] tw-pointer-events-none"
              />

              {/* Icon Container */}
              <div className="tw-w-14 tw-h-14 tw-rounded-2xl tw-bg-[#EEF2FF] tw-border tw-border-solid tw-border-[#C7D2FE] tw-flex tw-items-center tw-justify-center tw-mb-6">
                <img
                  src={item.icon}
                  alt={item.title}
                  className="tw-w-7 tw-h-7 tw-object-contain"
                  loading="lazy"
                />
              </div>

              {/* Text content */}
              <h3 className="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-3">
                {item.title}
              </h3>
              <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FeaturesList;
